import styled, { css } from "styled-components";

const Pad = styled.div`
  background-color: #c0c0c0;
  color: #000;
  border-radius: 100px;
  margin: 5px;
  height: 70px;
  width: 70px;
  display:flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${props => props.content === "=" && css`
    font-size:2.0rem;
  `}
  ${props => (props.content === "/" || props.content === "*") && css`
    font-size: 1.7rem;
  ` }
  ${props => props.type === "number" && css`
    background-color:#404040;
    color: #fff;
  `}
  ${props => (props.type === "operator" || props.content === "%") && css`
    background-color:hsl(49, 94%, 50%);
    color: #fff;
  `}
  ${props => props.content === "0" && css`
    width:140px;
    margin-right:15px;
  `}
`;

const Button = ({ type, content, handleClick }) => {
  return (
    <Pad type={type} content={content} onClick={handleClick}>
      <span>{content}</span>
    </Pad>
  );
};

export default Button;